import { api, cdnApi } from '~config/api';

const getMenu = async (menuId) => {
  try {
    const response = await cdnApi.get(`/menus/${menuId}.json?nocache=${Date.now()}`);
    if (response && response.ok && response.data) {
      return response.data;
    }
    throw new Error('Respuesta inválida');
  } catch (err) {
    console.error('[MenuService] Error en getMenu:', err);
    throw err;
  }
};

const getDisabledProducts = async (storeId) => {
  try {
    const response = await api.get(`/v1/disableds?store_id=${storeId}`);
    return response.data;
  } catch (err) {
    console.error('[MenuService] Error en getDisabledProducts:', err);
    throw err;
  }
};

export default {
  getMenu,
  getDisabledProducts
};
